import { FC } from "preact/compat";
import { isSameDay } from "date-fns";
import { Track } from "~/core";
import { useApp } from "~/core/store";
import { useAppTime } from "~/hooks";
import { leadZero } from "~/utils";
import { TileTotalTodayProps } from "./interfaces";

const getTotalSeconds = (tracks: Track[], now: Date) => {
    let seconds = 0;

    for (const track of tracks) {
        if (track.stop) {
            seconds += Math.floor((track.stop - track.start) / 1000);
        } else {
            seconds += Math.floor((now.getTime() - track.start) / 1000);
        }
    }

    return seconds;
};

const TileTotalToday: FC<TileTotalTodayProps> = ({ tile }) => {
    const {
        tracker: { activeTile },
        api: { time },
    } = useApp();
    const today = useAppTime("second", {
        skip: activeTile.value?.id !== tile.id,
    });
    const todayTracks = time.track.tracks.value.filter(
        (t) => t.group?.id === tile.id && isSameDay(t.start, today.value),
    );
    const totalSeconds = getTotalSeconds(todayTracks, today.value);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    return (
        <div className="font-bold tracking-wider">
            {leadZero(h)}:{leadZero(m)}:{leadZero(s)}
        </div>
    );
};

export default TileTotalToday;
